import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    this.tomSelect = new TomSelect(this.element, {
      create: false,
      sortField: {
        field: "text",
        direction: "asc"
      },
      onChange: () => {
        if (this.element.getAttribute("multiple") === "multiple") return;

        this.tomSelect.close();
        this.tomSelect.blur();
      }
    });
  }
}
